import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";
import { 
    CreatePickupGlobalMessageRequest, 
    EditPickupGlobalMessageRequest,
    TogglePickupGlobalMessageRequest,
    DeletePickupGlobalMessageRequest,
    GetPickupGlobalMessageRequest
} from "../../type/entities/pickup-global-message-type";

const PICKUP_GLOBAL_MESSAGES_ENDPOINT = "/pickup-global-messages";

export class PickupGlobalMessageService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE MENSAJES GLOBALES DE RECOGIDA
     * @EN GETS THE LIST OF PICKUP GLOBAL MESSAGES
     */
    // -------------------------------------------------------------------------------------------------------------
    listPickupGlobalMessages = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN MENSAJE GLOBAL DE RECOGIDA POR SU ID
     * @EN GETS A PICKUP GLOBAL MESSAGE BY ITS ID     
     */
    // -------------------------------------------------------------------------------------------------------------
    getPickupGlobalMessageById = async (messageId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/get",
            data: { id: messageId } as GetPickupGlobalMessageRequest,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN MENSAJE GLOBAL DE RECOGIDA
     * @EN CREATES A PICKUP GLOBAL MESSAGE
     */
    // -------------------------------------------------------------------------------------------------------------
    createPickupGlobalMessage = async (message: CreatePickupGlobalMessageRequest) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/create",
            data: message,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN MENSAJE GLOBAL DE RECOGIDA
     * @EN EDITS A PICKUP GLOBAL MESSAGE
     */
    // -------------------------------------------------------------------------------------------------------------
    editPickupGlobalMessage = async (message: EditPickupGlobalMessageRequest) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/edit",
            data: message,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA EL ESTADO ACTIVO DE UN MENSAJE GLOBAL DE RECOGIDA
     * @EN TOGGLES THE ACTIVE STATUS OF A PICKUP GLOBAL MESSAGE
     */
    // -------------------------------------------------------------------------------------------------------------
    togglePickupGlobalMessage = async (messageId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/toggle",
            data: { id: messageId } as TogglePickupGlobalMessageRequest,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN MENSAJE GLOBAL DE RECOGIDA
     * @EN DELETES A PICKUP GLOBAL MESSAGE
     */
    // -------------------------------------------------------------------------------------------------------------
    deletePickupGlobalMessage = async (messageId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/delete",
            data: {
                ids: [messageId]
            } as DeletePickupGlobalMessageRequest,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA MÚLTIPLES MENSAJES GLOBALES DE RECOGIDA
     * @EN DELETES MULTIPLE PICKUP GLOBAL MESSAGES
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiPickupGlobalMessages = async (ids: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_GLOBAL_MESSAGES_ENDPOINT + "/delete",
            data: { ids } as DeletePickupGlobalMessageRequest,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}